import React, { useEffect, useMemo, useState } from "react";
import { useDesktopKeyboardContext } from "../context/DesktopKeyboardContext";

interface CommandPaletteProps {
  open: boolean;
  onClose: () => void;
}

export default function CommandPalette({ open, onClose }: CommandPaletteProps) {
  const { commandBus } = useDesktopKeyboardContext();
  const [query, setQuery] = useState("");

  useEffect(() => {
    if (!open) setQuery("");
  }, [open]);

  const commands = useMemo(() => {
    const normalized = query.trim().toLowerCase();
    const all = commandBus.list();
    if (!normalized) return all.slice(0, 20);
    return all
      .filter((cmd) =>
        [cmd.title, cmd.id, cmd.category, ...(cmd.keywords || [])]
          .join(" ")
          .toLowerCase()
          .includes(normalized),
      )
      .slice(0, 30);
  }, [commandBus, query]);

  if (!open) return null;

  return (
    <div className="desktop-overlay" role="dialog" aria-modal="true">
      <div className="desktop-panel">
        <input
          autoFocus
          className="desktop-input"
          placeholder="Type a command"
          value={query}
          onChange={(event) => setQuery(event.target.value)}
          onKeyDown={(event) => {
            if (event.key === "Escape") onClose();
          }}
        />
        <ul className="desktop-list">
          {commands.map((command) => (
            <li key={command.id}>
              <button
                className="desktop-list-item"
                onClick={() => {
                  commandBus.execute(command.id, undefined, { source: "palette" });
                  onClose();
                }}
              >
                <span>{command.title}</span>
                <code>{command.id}</code>
              </button>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
}
